export class OsVersionLicense {
    public osVersion: string;
    public licenseKey : string;
    constructor(data?: any) {
     this.osVersion =  data && data.osVersion ? data.osVersion : '';
     this.licenseKey =  data &&  data.licenseKey ? data.licenseKey :'';
    }
 }
